
import { useState } from 'react';
import { ChatAvatar, SearchIcon, VerticalEllipsisIcon } from '../../../components/common/IconComponents';
import ChatPage from "../Chat/Chatpage";
import ChatCard from "../Chat/ChatCard";
import { chatCardData } from "../../../utils/Data";

const Chat = () => {
  // search
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (event) => {
    const inputText = event.target.value;
    const sanitizedText = inputText.replace(/\s/g, ''); // Remove spaces from the input text
    setSearchQuery(sanitizedText);
  };

  return (
    <div className="relative">
      <div className="flex flex-col md:flex-row px-3">
        <div className="w-full md:w-1/2 border-r-2 border-th-bg px-2">
          <nav className="w-full md:w-[354px] xl:w-[558px] fixed z-20 top-0 bg-white px-2">
            <p className="mb-3 text-xl mt-2 md:mt-5 font-medium">Chat</p>
            <div className="relative md:flex flex-initial hidden items-center justify-start mb-5">
              <input
                type="text"
                className="w-full lg:py-2 pl-11 pr-4 text-disabled text-xs md:text-sm lg:text-base font-normal bg-gray-50 border border-gray-50 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Search or Start a new Chat"
                value={searchQuery}
                onChange={handleSearch}
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
                <SearchIcon className="stroke-disabled" />
              </div>
            </div>
          </nav>

          <div className="md:mt-40">
            {chatCardData.map((data, index) => (
              <ChatCard
                key={index}
                photo={data.photo}
                name={data.name}
                post={data.post}
                time={data.time}
                badge={data.badge}
              />
            ))}
          </div>
        </div>

        <div className="w-full md:w-1/2">
          <nav className="md:w-[396px] xl:w-[596px] fixed z-20 top-0 bg-white px-2 flex justify-between items-center border-b-2 border-th-bg">
            <div className="flex items-center mt-2 md:mt-5 gap-3 p-2">
              <ChatAvatar />
              <p className="text-xl font-medium text-success-email">Juliet Frank</p>
            </div>

            <div className="flex justify-end mt-2 md:mt-5 gap-3 mr-3">
              <SearchIcon className="" />
              <VerticalEllipsisIcon className="w-[4px] h-[16px]" />
            </div>
          </nav>

          <div className="mt-24 md:mt-32 px-2">
            <ChatPage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;


// import { useState } from 'react';
// import { ChatAvatar, SearchIcon, VerticalEllipsisIcon } from '../../../components/common/IconComponents';
// import ChatPage from "../Chat/Chatpage";
// import ChatCard from  "../Chat/ChatCard";
// import { chatCardData } from "../../../utils/Data"; 

// const Chat = () => {
//   // search
//   const [searchQuery, setSearchQuery] = useState('');

//   const handleSearch = (event) => {
//     const inputText = event.target.value;
//     const sanitizedText = inputText.replace(/\s/g, ''); // Remove spaces from the input text
//     setSearchQuery(sanitizedText);
//   };

//   return (
//     <div className="">
//       <div className="flex">
//         <div className="w-1/2 border-r-2 border-th-bg px-2">
//           <div className="mt-5">
//             <p className="mb-4 text-xl font-medium">Chat</p>
//             <div className="relative flex-initial items-center justify-start mb-5">
//               <input
//                 type="text"
//                 className="w-full lg:py-2 pl-11 pr-4 text-disabled text-xs md:text-sm lg:text-base font-normal bg-gray-50 border border-gray-50 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="Search or Start a new Chat"
//                 value={searchQuery}
//                 onChange={handleSearch}
//               />
//               <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
//                 <SearchIcon className="h-5 w-4 stroke-disabled" />
//               </div>
//             </div>

//             {chatCardData.map((data, index) => (
//               <ChatCard
//                 key={index}
//                 photo={data.photo}
//                 name={data.name}
//                 post={data.post}
//                 time={data.time}
//                 badge={data.badge}
//               />
//             ))}
//           </div>
//         </div>

//         <div className="w-1/2">
//           <div className="flex items-center border-b-2 border-th-bg px-2">
//             <div className="flex items-center mt-5 gap-3 p-2 w-4/5">
//               <ChatAvatar />
//               <p className="text-xl font-medium text-success-email">Juliet Frank</p>
//             </div>

//             <div className="flex justify-end gap-3 mr-3 w-1/5 ">
//               <SearchIcon className="w-4" />
//               <VerticalEllipsisIcon className="w-[4px]" />
//             </div>
//           </div>

//           <div className="mt-3 px-2">
//             <ChatPage />
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Chat;

